import React from 'react';
import classNames from 'classnames';
import IconPen from '../../../../icons/pen';
import IconEmail from '../../../../icons/email';
import ArchiveIcon from '../../../../icons/archive-icon';
import IconSync from '../../../../icons/sync';
import moment from 'moment';


const DriverCard = (props) => {
    const {
        item,
        onOpenModalEdit,
        onOpenModalInvite,
        onOpenModalReset,
        onChangeDriverStatus,
    } = props;

    return (
        <div
            className={classNames("data-card p-3 mb-3", {
                "admin-card": item.role == "account_admin",
                "driver-card": item.role == "driver"
            })}
        >
            <div className="d-flex flex-wrap justify-content-between align-items-end mb-3">
                <div className="d-flex align-items-center">
                    <span className="h5 mb-0 mr-2">
                        {item.user.last_name || ''} {item.user.first_name || ''}
                    </span>
                </div>
                {item.role == 'account_admin' && (
                    <div>
                        <span className="badge badge-pill badge-info fw-600 py-1 px-4">
                            Admin
                        </span>
                    </div>
                )}
                {item.role == 'driver' ? (
                    <div>
                        <span className="badge badge-pill badge-dark py-1 px-4 border fw-600 text-white">
                            Driver
                        </span>
                    </div>
                ) : item.role == 'account_admin' && ['admin_driver', 'owner_operator'].includes(item.user_type) && (
                    <div>
                        <span className="badge badge-pill border-info py-1 px-4 border fw-600 text-info">
                            Also Drives
                        </span>
                    </div>
                )}
            </div>
            <div className="d-flex flex-wrap mb-3"
                style={{ gap: 10 }}
            >
                <div className="flex-1 d-flex flex-column">
                    <small className="text-muted">
                        ID
                    </small>
                    <span className="h6">
                        {item.id}
                    </span>
                </div>
                <div className="flex-1 d-flex flex-column">
                    <small className="text-muted">
                        Email
                    </small>
                    <span className="h6">
                        {item.user.email}
                    </span>
                </div>
                <div className="flex-1 d-flex flex-column">
                    <small className="text-muted">
                        Last Login
                    </small>
                    <span className="h6">
                        {item.user.last_login ? moment(item.user.last_login).format("MMM DD, YYYY") : 'Never'}
                    </span>
                </div>
                <div className="flex-1 d-flex flex-column">
                    <small className="text-muted">
                        Status
                    </small>
                    <div className="d-flex align-items-center">
                        <span
                            className={classNames("rounded-circle", {
                                "bg-success": item.active,
                                "bg-danger": !item.active,
                            })}
                            style={{ width: 10, height: 10 }}
                        />
                        <span className="h6 mb-0 ml-1">
                            {item.active ? 'Active' : 'Inactive'}
                        </span>
                    </div>
                </div>
                <div className="flex-1 d-flex flex-column">
                    <small className="text-muted">
                        Phone
                    </small>
                    <span className="h6">
                        {item.mobile_phone}
                    </span>
                </div>
            </div>
            <div
                className="d-flex justify-content-end gap-4"
                style={{ gap: 10 }}
            >
                <button type="button"
                    className="btn-hover d-flex align-items-center"
                    onClick={()=>onOpenModalEdit(item)}
                >
                    <span className="mr-1 h6 mb-0">Edit</span>
                    <IconPen className="vendor-icon" />
                </button>
                <button type="button"
                    className="btn-hover d-flex align-items-center"
                    onClick={()=>onOpenModalInvite(item)}
                >
                    <span className="mr-1 h6 mb-0">Resend invite</span>
                    <IconEmail className="vendor-icon" />
                </button>
                <button type="button"
                    className="btn-hover d-flex align-items-center"
                    onClick={()=>onOpenModalReset(item)}
                >
                    <span className="mr-1 h6 mb-0">Reset Password</span>
                    <i className="fa fa-key" style={{ fontSize: 12 }} />
                </button>
                <button type="button"
                    className={classNames("btn-hover d-flex align-items-center", {
                        "text-danger": item.active,
                        "text-success": !item.active,
                    })}
                    onClick={()=>onChangeDriverStatus(item)}
                >
                    {item.active ? (
                        <React.Fragment>
                            <span className="mr-1 h6 mb-0">Archive</span>
                            <ArchiveIcon className="vendor-icon" />
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <span className="mr-1 h6 mb-0">Reactivate</span>
                            <IconSync className="vendor-icon" />
                        </React.Fragment>
                    )}
                </button>
            </div>
        </div>
    )
}

export default DriverCard;
